import React from 'react';
import PropTypes from 'prop-types';
import config from '../../../config';
import classnames from 'classnames';

const LONG_BUTTON_IMAGE_SRC = '/images/amazon-login-with-amazon-button.png';
const SHORT_BUTTON_IMAGE_SRC = '/images/amazon-login-button.png';

const AmazonLoginButton = ({ onClick, isLongButton }) => (
    <div className="amazon-login__button-wrapper">
        <img
            className={ classnames('amazon-login__button', {
                'amazon-login__button--sandbox': config.get('amazonPayEnvironment') === 'sandbox',
                'amazon-login__button--long': isLongButton
            }) }
            onClick={ onClick }
            src={ isLongButton ? LONG_BUTTON_IMAGE_SRC : SHORT_BUTTON_IMAGE_SRC } />
        { isLongButton && <img
            className={ classnames('amazon-login__button amazon-login__button--short', { 'amazon-login__button--sandbox': config.get('amazonPayEnvironment') === 'sandbox' }) }
            onClick={ onClick }
            src={ SHORT_BUTTON_IMAGE_SRC } /> }
    </div>
);

AmazonLoginButton.propTypes = {
    isLongButton: PropTypes.bool,
    onClick: PropTypes.func.isRequired
};

AmazonLoginButton.defaultProps = {
    isLongButton: false
};

export default AmazonLoginButton;



// WEBPACK FOOTER //
// ./src/components/login/amazon/AmazonLoginButton.js